<template>
  <div class="container">
    <!-- <div :style="backgroundImage" class="video" /> -->
    <iframe v-if="video" :src="videoUrl" :title="video.name" class="video" width="1920" height="1080" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen />
  </div>
</template>

<script>
import Vimeo from 'vimeo';

export default {
  props: {
    id: { type: Number, required: true },
    image: { type: String, default: null },
  },
  data() {
    return {
      video: null,
    };
  },
  computed: {
    // backgroundImage() {
    //   const image = this.image ? this.image : 'https://www.thethinkingtraveller.com/media/Collection%20Images/New%20sizes/TTT_Sicily_Palermo_OCT17_014_1920x500.jpg';
    //   return {
    //     backgroundImage: `url(${image})`,
    //     backgroundSize: 'cover',
    //   };
    // },
    videoUrl() {
      if (this.video) return `${this.video.player_embed_url}&background=1&autoplay=1&loop=1&byline=1&title=1`;
    },
  },
  mounted() {
    // Client ID, Access token, Client secret
    const client = new Vimeo.Vimeo('fea0c63d46450f0e4b9e2f2e77dae40bc133349d', 'Zf3TsTGK06D6AZGcyVzgBQ3dpKOCh98LWZTqBbm+BsihcIETdYyiwISpurF9wrqM1hpXPohrNAL12vSNENRxYZX2w+/I1hFlmIdsdSJtcnK6vd27/0qTBiWezFONeaW5', '1f6cb9aaadcbc2670d0b31b008e91aeb');

    client.request({
      method: 'GET',
      path: `/users/196505877/videos/${this.id}?fields=player_embed_url,name`,
      // (error, body, status_code, headers)
    }, (error, body) => {
      // console.log('Vimeo', error, body);
      if (error) console.log('error', error);
      else this.video = body;
    });
  },
};

</script>

<style lang="scss" scoped>

.container {
  margin: 0;
  padding: 0;
  position: relative;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.video {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100vw;
  height: 100vh;
  transform: translate(-50%, -50%);
}

@media (min-aspect-ratio: 16/9) {
  .video {
    height: 56.25vw;
  }
}
@media (max-aspect-ratio: 16/9) {
  .video {
    width: 177.78vh;
  }
}

</style>
